function apiFetch(info: RequestInfo, init?: RequestInit) {
    return fetch(info, init).then((response) => {
        return response;
    }).catch((reason) => {
        if (!/check-in/.test(window.location.href) && (/\/api\//.test(info.toString()) && /failed to fetch/i.test(reason.message))) {
            window.location.href = window.location.protocol + '//' + window.location.host;
        } 
        return reason;
    });
}

export default apiFetch;